app.component("aiAgentsAdminConsole", {
    templateUrl: "app/src/js/components/admin/aiAgentsConsole.html",
    controller: "aiAgentsAdminController",
    bindings: {},
});

app.controller("aiAgentsAdminController", [
    "$scope",
    "AdminService",
    "ElevenLabsAPI",
    function ($scope, AdminService, ElevenLabsAPI) {

        $scope.practiceOptions = [];
        $scope.selectedPractice = null; // Single object instead of array
        $scope.statsLoading = false;
        $scope.monitoringStats = null;
        $scope.feedback = { message: "", success: false };

        $scope.timeRangeOptions = [
            { label: "Today", value: "today" },
            { label: "Last 7 Days", value: "7days" },
            { label: "Last 1 Month", value: "1month" },
            { label: "Last 6 Months", value: "6months" }
        ];
        $scope.filters = { selectedTimeRange: $scope.timeRangeOptions[3] };

        $scope.fetchPractices = function () {
            AdminService.getAvailablePractices().then(function (resp) {
                $scope.practiceOptions = resp.data;
            }, function (error) {
                $scope.feedback = { message: "Failed to load practices.", success: false };
            });
        };

        $scope.onPracticeChange = function () {
            if ($scope.selectedPractice) {
                $scope.fetchStatistics();
            } else {
                statsRequestId++;
                $scope.statsLoading = false;
                $scope.monitoringStats = null;
            }
        };

        let statsRequestId = 0;

        $scope.fetchStatistics = function () {
            if (!$scope.selectedPractice) return;
            $scope.feedback = { message: "", success: false };

            let startDate = moment();
            const range = $scope.filters.selectedTimeRange.value;

            if (range === 'today') startDate = moment().startOf('day');
            else if (range === '7days') startDate = moment().subtract(7, 'days');
            else if (range === '1month') startDate = moment().subtract(1, 'months');
            else startDate = moment().subtract(6, 'months');

            // Only the latest request may update the view, so a slow response for a previously
            // selected practice cannot show its stats under the current one.
            const requestId = ++statsRequestId;
            $scope.statsLoading = true;
            $scope.monitoringStats = null;
            ElevenLabsAPI.getMonitoringStatistics($scope.selectedPractice.id, startDate.toISOString(), moment().toISOString())
                .then(function (response) {
                    if (requestId !== statsRequestId) return;
                    $scope.monitoringStats = response.data;
                }, function (error) {
                    if (requestId !== statsRequestId) return;
                    $scope.feedback = { message: "Failed to load statistics.", success: false };
                })
                .finally(function () {
                    if (requestId !== statsRequestId) return;
                    $scope.statsLoading = false;
                });
        };

        $scope.formatDuration = function (decimalMinutes) {
            if (!decimalMinutes && decimalMinutes !== 0) return '0s';

            // Convert decimal minutes to total seconds
            let totalSeconds = Math.round(decimalMinutes * 60);

            const hours = Math.floor(totalSeconds / 3600);
            const minutes = Math.floor((totalSeconds % 3600) / 60);
            const seconds = totalSeconds % 60;

            let result = [];
            if (hours > 0) result.push(hours + 'h');
            if (minutes > 0 || hours > 0) result.push(minutes + 'm');
            result.push(seconds + 's');

            return result.join(' ');
        };

        // Initialize
        $scope.fetchPractices();
    }
]);